class LqdStackedSectionsHandler extends elementorModules.frontend.handlers.Base {

    onInit(...args) {

        super.onInit(...args);

        this.initStackedSections();

    }

    getDefaultSettings() {
        return {
            selectors: {
                stackedSectionsElement: '[data-lqd-stacked-sections]',
            }
        }
    }

    getDefaultElements() {
        const selectors = this.getSettings('selectors');
        return {
            $stackedSectionsElement: this.$element.find(selectors.stackedSectionsElement),
        }
    }

    initStackedSections() {

        this.elements.$stackedSectionsElement.liquidStackedSections();

    }

    onDestroy() {

        this.handleDestroy();

        super.onDestroy();

    }

    handleDestroy() {

        this.handleStackedSectionsDestroy();

    }

    handleStackedSectionsDestroy() {

        if (!this.elements.$stackedSectionsElement.length) return;

        const stackedSectionsData = this.elements.$stackedSectionsElement.data('plugin_liquidStackedSections');

        if (stackedSectionsData) {
            stackedSectionsData.destroy();
        }

    }

}

export default ($element) => {
    elementorFrontend.elementsHandler.addHandler( LqdStackedSectionsHandler, { $element } );
};